import Check from "@mui/icons-material/Check";
import QuestionMark from "@mui/icons-material/QuestionMark";
import Close from "@mui/icons-material/Close";
import { type SvgIconComponent } from "@mui/icons-material";

/**
 * Interne Domänen-Werte für den Verfügbarkeits_Status einer Fahrt.
 * Diese Werte bleiben unverändert (Req 2.1) — nur Anzeige-Texte und
 * Darstellung ändern sich. Der Zustand „keine Angabe" (Offen) ist
 * bewusst NICHT Teil von STATUS_META: er wird als gestrichelter Rahmen
 * ohne Icon im Rendering behandelt.
 */
export type AvailabilityStatus = "wish" | "optional" | "blocker";

/**
 * MUI-Palettenfarbe eines Status. `neutral` ist die eigene, dem Theme
 * hinzugefügte Farbe für „Ich kann nicht fahren" (grau, nicht rot).
 */
export type StatusColor = "success" | "warning" | "neutral";

/** Darstellungs-Metadaten pro Status (Farbe, Icon, i18n-Label-Key). */
export interface StatusMeta {
  /** MUI-Farbe (an Button/ToggleButton/Chip via `color`-Prop). */
  color: StatusColor;
  /** Icon aus `@mui/icons-material` (Status nie allein über Farbe, Req 2.2). */
  icon: SvgIconComponent;
  /** i18n-Katalog-Key für den Anzeige-Text (Text folgt in Task 4.2). */
  labelKey: string;
}

/**
 * Zentrales Statusmodell: ordnet jedem internen Domänen-Status seine
 * MUI-Farbe, sein Icon und seinen i18n-Label-Key zu (Req 2.1, 2.2).
 */
export const STATUS_META: Record<AvailabilityStatus, StatusMeta> = {
  wish: {
    color: "success",
    icon: Check,
    labelKey: "weeklyPlan.status.wish",
  },
  optional: {
    color: "warning",
    icon: QuestionMark,
    labelKey: "weeklyPlan.status.optional",
  },
  blocker: {
    color: "neutral",
    icon: Close,
    labelKey: "weeklyPlan.status.blocker",
  },
};
